import React from 'react';
import { 
  FileText, 
  EyeOff, 
  Calendar, 
  TrendingUp,
  MessageSquare,
  Heart,
  Loader
} from 'lucide-react';

const PublicationStats = ({ stats, loading }) => {
  if (loading) {
    return (
      <div className="mb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="bg-white rounded-lg p-6 border border-gray-100 animate-pulse">
              <div className="flex items-center justify-between mb-4">
                <div className="w-12 h-12 bg-gray-200 rounded-lg"></div>
              </div>
              <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
              <div className="h-8 bg-gray-200 rounded w-1/2"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!stats) return null;

  const statCards = [
    {
      title: 'Total Publications',
      value: stats?.total_publications || 0,
      icon: FileText,
      color: 'bg-gradient-to-br from-blue-500 to-blue-600',
      bgLight: 'bg-blue-50',
      textColor: 'text-blue-700',
      borderColor: 'border-blue-200'
    },
    {
      title: 'Publications masquées',
      value: stats?.publications_masquees || 0,
      icon: EyeOff,
      color: 'bg-gradient-to-br from-red-500 to-red-600',
      bgLight: 'bg-red-50',
      textColor: 'text-red-700',
      borderColor: 'border-red-200'
    },
    {
      title: 'Cette semaine',
      value: stats?.publications_semaine || 0,
      icon: Calendar,
      color: 'bg-gradient-to-br from-green-500 to-green-600',
      bgLight: 'bg-green-50',
      textColor: 'text-green-700',
      borderColor: 'border-green-200'
    },
    {
      title: 'Ce mois',
      value: stats?.publications_mois || 0,
      icon: TrendingUp,
      color: 'bg-gradient-to-br from-[#FF6B00] to-[#e55d00]',
      bgLight: 'bg-orange-50',
      textColor: 'text-[#FF6B00]',
      borderColor: 'border-orange-200'
    }
  ];

  return (
    <div className="mb-6">
      {/* Cards de statistiques */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {statCards.map((stat, index) => (
          <div 
            key={index} 
            className={`${stat.bgLight} rounded-xl p-5 border ${stat.borderColor} hover:shadow-lg transition-all duration-200 transform hover:-translate-y-1`}
          >
            <div className="flex items-center justify-between mb-3">
              <div className={`${stat.color} p-3 rounded-xl shadow-md`}>
                <stat.icon size={24} className="text-white" />
              </div>
            </div>
            <h3 className="text-sm font-medium text-gray-600 mb-1">{stat.title}</h3>
            <p className={`text-3xl font-bold ${stat.textColor}`}>
              {stat.value.toLocaleString()}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PublicationStats;
